<div class="main">
    <ngx-spinner bdColor="rgba(51,51,51,0.55)"
                size="medium"
                color="#fff"
                type="line-spin-clockwise-fade"
                [fullScreen]="false">
        <p class="loading">{{'general.loading' | translate}}...</p>
    </ngx-spinner>
    <div class="row pr-3 pl-3">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <h2 class="page-title" tabindex="0">{{'breadcrumb.approve-notifications' | translate}}</h2>
                </div>
            </div>
            <xng-breadcrumb separator=" > ">
                <ng-container *xngBreadcrumbItem="let breadcrumb">
                    <span *ngIf="breadcrumb">
                        {{ 'breadcrumb.' + breadcrumb | translate }}
                    </span>
                </ng-container>
            </xng-breadcrumb>

            <div *ngIf="approver">
                <div class="row text-right" *ngxPermissionsOnly="['Owner', 'Admin', 'Supervisor']">
                    <div class="col-12">
                        <button title="{{'general.deny' | translate}}" class="btn btn-red btn-h-red mb-2" (click)="approveSelected(false)">
                            {{'general.deny' | translate}}
                        </button>
                        <button title="{{'general.approve' | translate}}" class="btn btn-green btn-h-green mb-2 ml-2" (click)="approveSelected(true)">
                            {{'general.approve' | translate}}
                        </button>
                    </div>
                </div>
        
                <table class="border-top" mat-table [dataSource]="dataSource" matSort matSortActive="sentDate" matSortDirection="asc" #Sort="matSort" (matSortChange)="sortData($event)" matSortDisableClear>
                    <ng-container matColumnDef="check">
                        <th mat-header-cell *matHeaderCellDef><label class="mr-2 mb-0" for="checkAllNotis">{{'general.select_all' | translate}}</label><input id="checkAllNotis" type="checkbox" (click)="checkAllNotis()"></th>
                        <td mat-cell *matCellDef="let notification"> <input name="selectedNotis" [id]="notification.id" type="checkbox" title="{{notification.id}}"  (click)="selectNoti(notification.id)" [checked]="(checkedNotifications.includes(notification.id.toString()))"> </td>
                    </ng-container>
                    <ng-container matColumnDef="message">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'notification.message' | translate}} </th>
                        <td class="text-break" mat-cell *matCellDef="let notification" [attr.role]="null"> {{notification.message}} </td>
                    </ng-container>
                    <ng-container matColumnDef="userGroup">
                        <th mat-header-cell *matHeaderCellDef [attr.role]="null" scope="col"> {{'notification.send_to' | translate}} </th>
                        <td mat-cell *matCellDef="let notification" [attr.role]="null">{{ notification.tagName?functionsService.formatMultiGroupName(notification.tagName):"" }} </td>
                    </ng-container>
                    <ng-container matColumnDef="sentBy">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'notification.to_be_sent_by' | translate}} </th>
                        <td mat-cell *matCellDef="let notification" [attr.role]="null"> {{notification.sentFirstName}} {{notification.sentLastName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="sentDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'notification.approval_request' | translate}} </th>
                        <td mat-cell *matCellDef="let notification" [attr.role]="null"> {{functionsService.convertUTCDateToLocalDate(notification.sentDate)}} </td>
                    </ng-container>
                    <ng-container matColumnDef="scheduled">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'notification.scheduled' | translate}} </th>
                        <td mat-cell *matCellDef="let notification" [attr.role]="null"> {{notification.scheduled?functionsService.convertUTCDateToLocalDate(notification.scheduled):""}} </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="centre" [attr.role]="null" scope="col"> {{'general.action' | translate}} </th>
                        <td mat-cell *matCellDef="let notification" [attr.role]="null">
                            <button class="btn btn-blue btn-h-blue btn-sm" (click)="viewNotification(notification.id)" title="{{'alert.details' | translate}}"><i class="fa fa-eye"></i> {{'alert.details' | translate}}</button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns" [attr.role]="null"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [attr.role]="null"></tr>
                </table>
                <mat-paginator #paginator [length]="totalLength" (page)="nextPage($event)" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</div>
       